import React, { useEffect } from 'react'
import { useStyles } from './style'
import { Box } from '@material-ui/core'
import TableOutline from '../../elements/table'
import { Link } from 'react-router-dom'
import AllRequests from '../../layouts/Requests/index'

function Requests(props) {
  const classes = useStyles()

  const getColumns = (type) => ([
    ...(type === 'account' ?
      [] : [{
        id: 'programName',
        header: 'PROGRAM NAME',
        isLink: true
      }]),
    {
      id: 'accountName',
      header: 'ACCOUNT NAME',
      isLink: type === 'account'
    },
    {
      id: 'requestedBy',
      header: 'REQUESTED BY'
    },
  ])

  return (
    <Box p={2} className={classes.requestContainer}>
      <div className={classes.headerWrapper}>
        <Box display="flex">
          <Box mr={0.5}>{'Requests'}</Box>
          <Box fontWeight="400">{`${props.totalRequests && ' (' + props.totalRequests + ')'}`}</Box>
        </Box>
        <Link className={classes.link} to="admin/requests">View More</Link>
      </div>
      <Box mt={2}>
        <AllRequests page='admin' columns={getColumns} />
        {/* <TableOutline tableHeadings={columns} /> */}
      </Box>
    </Box>
  )
}

export default Requests